import { Container, Reveal, Section, SectionHead } from '@nexa/ui';
import { useCopy } from '@/core/i18n';
import { FeatureRow } from './FeatureRow.tsx';
import { TopicList } from './TopicList.tsx';

/**
 * `#collab` — hai cột `1fr 1fr` gap 72px ở `xl`, một cột ở dưới (`template.html` dòng 812–836).
 *
 * `tone="muted"` là nền `ink-50` cộng kẻ trên/dưới `ink-100` — đo được ở dòng 812, và đây là
 * section xen kẽ duy nhất trong ba section của lô B.
 *
 * `items-center` chỉ có nghĩa khi hai cột đứng cạnh nhau; ở một cột nó vô hại, nhưng thứ tự DOM
 * trở thành thứ tự đọc nên cột trái (nội dung) phải đứng TRƯỚC cột phải (mock minh hoạ).
 */
export function CollabSection() {
  const copy = useCopy();

  return (
    <Section id="collab" tone="muted" labelledBy="collab-head" cv className="nx-cv-collab">
      <Container width="content">
        <div className="grid grid-cols-1 items-center gap-10 xl:grid-cols-2 xl:gap-[72px]">
          <Reveal>
            <SectionHead
              id="collab-head"
              eyebrow={copy.collab.eyebrow}
              heading={copy.collab.heading}
              lead={copy.collab.lead}
              // Thiết kế vẽ `#collab` bằng bậc chữ NHỎ hơn mặc định: h2 38px (dòng 816) và lead
              // 16.5px (dòng 817). Đếm toàn file: 38px xuất hiện 4 lần — #collab, #pm, #knowledge,
              // #pricing; 16.5px xuất hiện 3 lần — #collab, #pm, #security. Xem `tokens.css` mục
              // `--text-h2-compact` và `--text-lead-compact`.
              headingSize="h2-compact"
              leadSize="lead-compact"
            />

            <div className="mt-[26px] flex flex-col gap-3.5">
              {copy.collab.features.map((feature) => (
                <FeatureRow key={feature.term} {...feature} />
              ))}
            </div>
          </Reveal>

          <Reveal className="nx-rv-right">
            <TopicList
              channel={copy.collab.mock.channel}
              topicCount={copy.collab.mock.topicCount}
              topics={copy.collab.mock.topics}
              scheduled={copy.collab.mock.scheduled}
            />
          </Reveal>
        </div>
      </Container>
    </Section>
  );
}
